import { Button, Text } from '@zrsystem/ui';
import { useState } from 'react';

import { useAuth } from '@/app/providers/auth-provider.js';
import { completeCurrentOrganizationAsCompany } from '@/features/platform/api/complete-organization-as-company.api.js';
import { CompleteOrganizationAsCompanyForm } from '@/features/platform/components/complete-organization-as-company-form.js';

export function IndividualOrganizationCompletionBanner() {
  const { user, refreshUser } = useAuth();
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (user?.personKind !== 'INDIVIDUAL' || user.tenantId === undefined) {
    return null;
  }

  const canComplete = (user.accesses ?? []).some(
    (access) => access.scopeType === 'TENANT' && access.tenantId === user.tenantId,
  );
  if (!canComplete) {
    return null;
  }

  return (
    <section className="individual-organization-completion-banner">
      <Text variant="small">
        Esta oficina está cadastrada como pessoa física. O módulo fiscal permanece desligado até a
        conclusão como pessoa jurídica.
      </Text>
      {open ? (
        <CompleteOrganizationAsCompanyForm
          isSubmitting={isSubmitting}
          onCancel={() => {
            setOpen(false);
          }}
          onSubmit={async (body) => {
            setIsSubmitting(true);
            try {
              await completeCurrentOrganizationAsCompany(body);
              await refreshUser();
              setOpen(false);
            } finally {
              setIsSubmitting(false);
            }
          }}
        />
      ) : (
        <Button
          type="button"
          variant="secondary"
          size="sm"
          onClick={() => {
            setOpen(true);
          }}
        >
          Concluir como pessoa jurídica
        </Button>
      )}
    </section>
  );
}
